<template>
  <div class="esp_page_card" :style="{ height: height, padding: padding }">
    <div class="esp_card_head" :style="{ borderColor: borderColor }">
      <div class="esp_head_left">
        <slot name="left">
          <span :style="{color: titleFontColor}">{{ title }}</span>
        </slot>
      </div>
      <div class="esp_head_right">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="esp_card_body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EspPageCard',
    data() {
      return {}
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      height: {
        type: String,
        default: 'auto'
      },
      padding: {
        type: String,
        default: '0px 0px 10px 0px'
      },
      titleFontColor: {
        type: String,
        default: 'none'
      },
      borderColor: {
        type: String,
        default: '#e8e8e8'
      }
    }
  }
</script>

<style scoped lang="less">
  .esp_page_card {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;

    .esp_card_head {
      min-height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid;
      padding: 0px 0px 5px 0px;
      box-sizing: border-box;

      .esp_head_left {
        position: relative;
        padding-left: 12px;
        font-weight: bold;
        font-size: @pageCardTitleFontSize;
        color: @pageCardTitleFontColor;
        position: relative;

        &:before {
          content: "";
          display: block;
          width: 4px;
          background-color: @pageCardHeadLineColor;
          position: absolute;
          left: 0px;
          top: 1px;
          bottom: -1px;
          -webkit-border-radius: 2px;
          -moz-border-radius: 2px;
          border-radius: 2px;
        }
      }
    }

    .esp_card_body {
      flex: 1;
      padding: 5px 0px 0px 0px;
      box-sizing: border-box;
      overflow: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageCard.vue